import { render, staticRenderFns } from "./NursingProjectList.vue?vue&type=template&id=f815e3c4&scoped=true"
import script from "./NursingProjectList.vue?vue&type=script&lang=js"
export * from "./NursingProjectList.vue?vue&type=script&lang=js"
import style0 from "./NursingProjectList.vue?vue&type=style&index=0&id=f815e3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f815e3c4",
  null
  
)

export default component.exports